
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('subtitleButton.vrun.component', () => import('./SubtitleButton.vue'))